<script setup>
import page404Animation from "@/assets/images/404-maintenance/page-404-animation.gif";
import panneauCora from "@/assets/images/404-maintenance/panneau-cora.svg";
</script>
<script>
import LazyImage from "@/components/atoms/lazy-image";
import ButtonIcon from "@/components/molecules/button-icon";
import Container from "@/components/atoms/container";
export default {
  name: "Page404",
  components: {
    LazyImage,
    ButtonIcon,
    Container
  },
  props: {
    magasinName: {
      type: String,
      required: true
    },
    status: {
      type: Number,
      required: false,
      default: 404 // 404 prospectus inconnu, 410 prospectus expiré
    },
    borne: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div class="u-bgcolor-white u-pb-xlg">
    <Container>
      <div class="u-flex u-flex-justify-center u-mb-xlg">
        <LazyImage
          :src="panneauCora"
          alt=""
          width="180"
          height="131"
          class="u-ml-lg u-mr-lg"
        />
      </div>
      <div class="u-flex u-flex-column@md u-flex-justify-center u-flex-align-center u-mb-xlg">
        <LazyImage
          :src="
            page404Animation
          "
          alt=""
          width="380"
          height="179"
          class="u-mr-xlg"
        />
        <div class="u-text-center@md">
          <p class="u-font-50 u-font-30@md u-font-secondary u-color-primary u-font-700">
            Le magasin de {{ magasinName }} ne propose <template v-if="status === 410">plus</template><template v-else>pas</template> ce prospectus.
          </p>
          <p class="u-font-18 u-font-15@md u-color-grey-1">
            D’autres prospectus sont disponibles :
          </p>
        </div>
      </div>
      <div class="u-flex u-flex-column@sm u-flex-justify-center u-flex-align-center@sm u-ml-xlg@sm u-mr-xlg@sm u-ml-none@xs u-mr-none@xs">
        <ButtonIcon
          icon-name="basket"
          variant="secondary"
          icon-color="white"
          radius="full"
          class="u-mr-lg u-mr-none@sm u-mb-sm@sm u-full-width@sm"
          size="md"
          :to="borne ? '/prospectus/borne' :'/prospectus'"
        >
          Consulter les autres prospectus
        </ButtonIcon>
      </div>
    </Container>
  </div>
</template>

<style lang="scss" scoped></style>
